module.exports = __webpack_public_path__ + "static/media/corporate-services-img14.3e0e32c5.jpg";